// src/core/auth-guard.ts

import { PUBLIC_ROUTES } from '../constants/constantsData';
import { checkMenuAccess, Pong } from '../api/ai.api';

export async function initAuthGuard(): Promise<boolean> {
    var isCheckingAuth = true;

    // 1. Tạo và hiển thị Loading Page chèn vào body
    const loadingOverlay = document.createElement('div');
    loadingOverlay.id = 'auth-loading-overlay';
    loadingOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(255, 255, 255, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        transition: opacity 0.2s ease;
    `;
    loadingOverlay.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: center; gap: 12px;">
            <i class="fas fa-spinner fa-spin" style="font-size: 36px; color: #11A75D;"></i>
            <span style="font-size: 14px; font-weight: 500; color: #495057;">Đang kiểm tra quyền truy cập...</span>
        </div>
    `;
    document.body.appendChild(loadingOverlay);

    // Hàm tiện ích để dọn dẹp loading overlay
    const removeLoading = () => {
        if (loadingOverlay && loadingOverlay.parentNode) {
            loadingOverlay.parentNode.removeChild(loadingOverlay);
        }
    };

    try {
        const currentPath =
            window.location.hash.replace(/^#/, '').split('?')[0] || '/';

        // ============================================================
        // Public route
        // ============================================================
        const isPublicRoute = PUBLIC_ROUTES.some(route =>
            currentPath.startsWith(route)
        );

        if (isPublicRoute) {
            return true;
        }

        // ============================================================
        // Không có access token
        // ============================================================
        const token = localStorage.getItem('accessToken');

        if (!token) {
            const returnUrl = encodeURIComponent(
                window.location.hash || '#/'
            );

            window.location.href = `/#/login?returnUrl=${returnUrl}`;
            return false;
        }

        // ============================================================
        // Check quyền với Backend
        // ============================================================
        console.log('Kiểm tra quyền truy cập cho route:', currentPath, currentPath === '/', 'auth-guard.ts');
        if (currentPath === '/dashboard' || currentPath === '/') {
            return true;
        }

        try {
            const result = await checkMenuAccess(currentPath);
            console.log(await Pong(currentPath))
            if (!result.allowed) {
                window.location.href = '/#/403';
                return false;
            }
        } catch (error) {
            console.error('Cannot check menu permission:', error);
            window.location.href = '/#/403';
            return false;
        }

        return isCheckingAuth;
    } finally {
        // Dù luồng trả về true hay false (bị chuyển hướng), loading luôn được đóng lại
        removeLoading();
    }
}

// initAuthGuard();